<template>
  <div class="IlanBg" v-loading="lo">
    <ul class="IlanListesi" v-if="Liste">
      <li v-for="l in Liste"  @click="DuyuruDetay(l)">
        <img v-if="l.Resim.Data" :src="l.Resim.Url+l.Resim.Data">
        <span class="IlanBaslik">{{ l.Baslik }}</span>
<!--        <span class="IlanFiyat" v-if="l.Fiyat">{{ l.Fiyat }}<sup>TL</sup></span>-->
      </li>
    </ul>
    <el-dialog v-if="ModalOlayi" :title="Detay.Baslik" :visible.sync="ModalOlayi" width="30%">
      <a @click="ModalOlayi = false" class="ModalKapat"><i class="el-icon-close"></i></a>
      <div class="firsatdetay">
        <h5>{{ Detay.Aciklama }}</h5>
        <p v-html="Detay.Icerik"></p>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Yukleniyor from "../../Doc/Yukleniyor";

export default {
  components: {Yukleniyor},
  data() {
    return {
      Liste: null,
      Detay: null,
      lo: false,
      ModalOlayi: false
    }
  },
  methods: {
    DuyuruDetay(detay) {
      this.Detay = detay;
      this.ModalOlayi = true;
    },
    SayfaYukle() {
      this.lo = true
      this.$store.dispatch("Get", {path: 'panel/duyuru'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Liste = response.Data
            this.lo = false
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
    },

  },
  created() {
    this.SayfaYukle()
  }
}
</script>

<style scoped>
.IlanBg {
  border: 1px solid #dcdfe5;
  height: 200px;
  border-radius: 3px;
  padding: 5px;
  position: relative;
}

.IlanBg h5 svg {
  width: 20px;
  height: 20px;
}

.IlanListesi {
  height: 190px;
  overflow-y: scroll;
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 12px;


}

.IlanListesi .IlanBaslik {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  display: inline-block;
  line-height: 12px;
}

.IlanListesi .IlanFiyat {
  float: right;
  font-size: 10px;
  line-height: 25px;
  right: -5px;
  display: inline-block;
  position: relative;
}

.IlanListesi li {
  cursor: pointer;
  padding: 5px;
  margin-bottom: 4px;
  height: 20px;
  position: relative;
  padding-left: 20px;
  font-weight: bold;

}

.IlanListesi li img {
  max-height: 15px;
  position: absolute;
  top: 3px;
  left: 0px;

}

.IlanListesi li.onecikar span {
  width: 100%;

}

.IlanListesi li:nth-child(odd) {
}

.IlanListesi li:nth-child(even) {
  /*background: rgba(236, 237, 246, 1);*/
}

.IlanBg h5 {
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 16px;
  text-transform: uppercase;
  font-weight: 500;
  margin-bottom: 15px;
}

.IlanBg .footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  background: #8996a0;
  padding: 0 5px;
  padding-top: 2px;
}

.IlanBg .footer a {
  font-size: 8px;
  text-transform: uppercase;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Pack/Panel/PanelFirsat.vue